import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'timeDate',
  pure: false,
  standalone: true
})
export class TimeDatePipe implements PipeTransform {
  private transloco = inject(TranslocoService);

  private readonly monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  transform(date: Date | null): string {
    if (!date) {
      return '--';
    }

    const parsedDate = new Date(date);
    const now = new Date();
    const secondsAgo = Math.floor((now.getTime() - parsedDate.getTime()) / 1000);

    if (secondsAgo < 60) {
      return this.transloco.translate('COMMON.FEW_SECONDS_AGO');
    }

    const minutesAgo = Math.floor(secondsAgo / 60);

    if (minutesAgo < 60) {
      if (minutesAgo === 1) {
        return this.transloco.translate('COMMON.MINUTE_AGO');
      }
      return this.transloco.translate('COMMON.MINUTES_AGO', { count: minutesAgo });
    }

    const hoursAgo = Math.floor(minutesAgo / 60);

    if (hoursAgo < 24) {
      if (hoursAgo === 1) {
        return this.transloco.translate('COMMON.HOUR_AGO');
      }
      return this.transloco.translate('COMMON.HOURS_AGO', { count: hoursAgo });
    }

    return this.transloco.translate('COMMON.ON') + ' ' + this.formatDate(parsedDate);
  }

  private formatDate(date: Date): string {
    const day = date.getDate();
    const month = this.monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }
}